<template>
  <app-view @open="onOpen" @restore="onRestore" @close="onClose">
    <list ref="list" :loadNextPage="loadNextPage" :clear="clear">
      <div class="content">
        <movie-cover v-for="(item,index) in bookshelf" :key="index" :value="item"></movie-cover>
      </div>
    </list>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'
  import List from '../components/List.vue'
  import MovieCover from '../components/MovieCover.vue'

  export default {
    components: {AppView, List, MovieCover},
    computed: {
      catid () {
        return this.$route.params.catid
      },
      catname () {
        return this.$route.query.name
      },
      recommendation () {
        return this.$route.query.recmd
      },
      bid () {
        return this.$route.query.bid
      },
      bookshelf () {
        return this.$service.movie.bookshelf
      }
    },
    methods: {
      clear () {
        this.$service.movie.clearBookShelf()
      },
      async loadNextPage () {
        if (this.catid) {
          let catid=parseInt(this.catid);
          if(isNaN(catid)){
            return await this.$service.movie.loadBookShelfByRecommendation()
          }else{
            return await this.$service.movie.loadBookShelfByCategory(this.catid)
          }
        } else if (this.bid) {
          return await this.$service.movie.loadBookShelfByBible(this.bid)
        } else {
          return await this.$service.movie.loadBookShelfByRecommendation(parseInt(this.recommendation))
        }
      },
      onOpen () {
        this.$refs.list.reload()
        this.$service.common.title = this.catname
        let link = `https://${window.location.host}/#/bookshelf`
        if (this.catid) {
          link = link + '/' + this.catid + '?name=' + this.catname
        } else if (this.bid) {
          link = link + '?bid=' + this.bid + '&name=' + this.catname
        } else {
          link = link + '?recmd=' + this.recommendation + '&name=' + this.catname
        }
        setTimeout(() => {
          this.$service.wechat.callShare({
            title: this.catname,
            link
          })
        }, 2000)
      },
      onRestore () {
        if (this.bookshelf.length > 0) {
          this.$service.common.title = this.catname
        } else {
          this.onOpen()
        }
      },
      onClose () {
        this.clear()
      }
    }
  }
</script>
<style scoped lang='scss'>
  .view {
    .content {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      padding: rem(6);
      > a {
        margin: rem(6);
      }
    }
    @media screen and (min-width: 768px) {
      .content {
        padding: rem(3);
        > a {
          margin: rem(3.5);
        }
      }
    }

    @media screen and (min-width: 1024px) {
      .content {
        padding: rem(3);
        > a {
          margin: rem(2.5);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?af9e7b84